export const REDUCER_KEY = 'podcasts';
export const SET_PODCASTS = 'SET_PODCASTS';
